import gql from "graphql-tag";

import { Fragment, Profession } from "../types";

export const PROFESSION_FRAGMENT = gql`
  fragment ProfessionFragment on Profession {
    id
    name
    skills {
      id
      name
      kind
      locale
    }
  }
`;

export type ProfessionFragment = Fragment<Profession, Profession>;
